import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Icon } from '@material-ui/core'
import clsx from 'clsx'
import { SketchPicker } from 'react-color'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import SecondaryButton from 'app/components/buttons/SecondaryButton'

const useStyles = makeStyles((theme) => ({
  boxColor: {
    backgroundColor: '#ffffff',
    boxShadow: '1px 1px #a7a4a4',
    '& .sketch-picker': {
      boxShadow: 'unset !important',
    },
  },
  typography: {
    padding: theme.spacing(2),
  },

  templateDefault: {
    height: '20px',
    border: '1px solid #aaabad',
  },
}))

const ColorSelector = (props) => {
  const { currentState, onChange, templateColor } = props
  const classes = useStyles()

  const [color, setColor] = useState(currentState.color || templateColor)
  const [isOpen, setIsOpen] = useState(false)

  const stopPropagation = (event) => {
    event.stopPropagation()
  }

  const handleChangeComplete = (color) => {
    setColor(color.hex)
  }

  const onSelectedColor = () => {
    onChange('color', color)
    onClose()
  }

  const onClose = () => {
    setIsOpen(false)
  }

  const onOpen = () => {
    setIsOpen(true)
  }

  const onDefaultTemplateColor = () => {
    setColor(currentState.color)
  }

  return (
    <div
      aria-haspopup="true"
      aria-label="rdw-color-picker"
      className="relative"
    >
      <div
        className="rdw-option-wrapper p-2"
        style={{ color: currentState.color }}
        onClick={onOpen}
      >
        <Icon>colorize</Icon>
      </div>
      {isOpen ? (
        <div className="absolute z-10" onClick={stopPropagation}>
          <div className={classes.boxColor}>
            <div className="p-4">
              <div>
                <PrimaryButton
                  className="w-1/2"
                  labelId={'action.ok'}
                  onClick={onSelectedColor}
                />
                <SecondaryButton
                  className="w-1/2"
                  labelId="action.cancel"
                  onClick={onClose}
                />
              </div>
              <div className="p-4 pt-5">
                <div
                  onClick={onDefaultTemplateColor}
                  className={clsx(
                    'w-full cursor-pointer',
                    classes.templateDefault,
                  )}
                  style={{ backgroundColor: currentState.color }}
                ></div>
              </div>
            </div>
            <SketchPicker color={color} onChange={handleChangeComplete} />
          </div>
        </div>
      ) : undefined}
    </div>
  )
}
export default ColorSelector
